import { InterInstance } from './config';

export const getFaqs = async (id: string) => {
  try {
    const  data  = await InterInstance.get(`frequent-question?companyId=${id}`, {
      //headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (e) {
    return e;
  }
};
